
















































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import { uploadPOST } from '@/api/api'
import { StockInOrderMaterialServiceProxy, TestMaterialDTO } from '@/service-proxies/app-v2/wms.service-proxies'
const stockInOrderMaterialServiceProxy = new StockInOrderMaterialServiceProxy()
export default Vue.extend({
  data(){
    return {
      form: this.$form.createForm(this),
      loading: false,
      objectKey: '',
      fileName: '',
      contentType: '',
      file: {}
    }
  },
  props:{
    visible:{
      type: Boolean,
      default: false
    },
    currentRow: {
      type: Object,
      default: () => ({})
    }
  },
  methods:{
    close(){
      this.form.resetFields()
      this.file = {}
      this.$emit('close')
    },
    beforeUpload(file) {
      this.file = file;
    },
    save(flag){
      this.form.validateFields((err, values) => {
        if (!err) {
          const param = new TestMaterialDTO({
            fileName: this.fileName,
            fileObjectKey: this.objectKey,
            contentType: this.contentType,
            id: this.currentRow.id,
            model: flag,
            testResult: values.testResult ? 1 : 0
          })
          stockInOrderMaterialServiceProxy.testMaterial(param).then(res => {
            this.form.resetFields()
            this.file = {}
            this.$message.success(this.$t('page_user_management_new_success'))
            this.$emit('reload')
          })
        }
      });
    },
    uploadFile(file: any) {
      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      uploadPOST(formData).then((res: any) => {
        this.loading = false
        if (res.data.data) {
          this.objectKey = res.data.data.objectKey
          this.fileName = res.data.data.originalFilename
          this.contentType = res.data.data.contentType
          console.log(res.data.data,this.objectKey,this.fileName,this.contentType)
        }
      }).catch(() =>{
        this.loading = false
      })
    },
  }
})

